export const PATHS = {
  DETAILS: '/client',
};

export const TRANSLATION_KEY = 'client-details';
